exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/variables/colors.css"), undefined);

// module
exports.push([module.id, "._2Pvj-Tg8hjB756iJeKyt3w path {\n  fill: none;\n  stroke: " + require("-!../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/variables/colors.css").locals["waveformBlack"] + ";\n  stroke-width: 1.5px;\n  stroke-linejoin: round;\n}\n", ""]);

// exports
exports.locals = {
	"waveformBlack": "" + require("-!../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/variables/colors.css").locals["waveformBlack"] + "",
	"tracing": "_2Pvj-Tg8hjB756iJeKyt3w"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/components/Waveform/Waveform.css
// module id = 8989
// module chunks = 23